module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres6ke"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.app.nowLang,
      "unLoadBool": true,
      "columns": _vm.columns[_vm.app.nowLang].index,
      "receivedStore": _vm.receivedHres6keIndex,
      "searchBoxAlias": "request",
      "addEvent": _vm.addEvent,
      "editEvent": _vm.editEvent,
      "cancelEvent": _vm.cancelEvent
    },
    model: {
      value: (_vm.searchParams),
      callback: function($$v) {
        _vm.searchParams = $$v
      },
      expression: "searchParams"
    }
  }), _vm._v(" "), (_vm.detailDisp) ? _c('detail', {
    attrs: {
      "labels": _vm.labels[_vm.app.nowLang],
      "labelsButton": _vm.app.button[_vm.app.nowLang],
      "detail": _vm.detail,
      "currentDtereq": _vm.currentDtereq,
      "currentNumseq": _vm.detail.numseq,
      "currentCodempid": _vm.codempid,
      "nowLang": _vm.app.nowLang,
      "toggle": _vm.toggle,
      "postHres6keSave": _vm.postHres6keSave,
      "indexSelected": _vm.indexSelected,
      "arrCodrem": _vm.dropdowns.codrem,
      "searchParams": _vm.searchParams,
      "descCodapp": _vm.dash.descCodapp,
      "receivedHres6keIndex": _vm.receivedHres6keIndex
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5af97a5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6ke/component.vue
// module id = 3793
// module chunks = 1